(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const knapp = event.target instanceof Element ? event.target.closest('.kb-ruta__mer') : null;
    if (!knapp) return;
    const oppen = knapp.closest('.kb-ruta')?.classList.toggle('kb-ruta--oppen');
    knapp.setAttribute('aria-expanded', String(Boolean(oppen)));
    knapp.textContent = oppen ? 'Visa mindre' : 'Läs mer';
  });

  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
